'use client'

import { useEffect } from 'react'
import { useSearchParams } from 'next/navigation'

const APP_WEBVIEW_COOKIE = 'is_app_webview'
const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 30

const persistAppWebviewState = () => {
    if (typeof window === 'undefined') return

    const queryParams = new URLSearchParams(window.location.search)
    const hasAppFlag = queryParams.get('isApp') === 'true'

    if (hasAppFlag) {
        document.cookie = `${APP_WEBVIEW_COOKIE}=true; path=/; max-age=${COOKIE_MAX_AGE_SECONDS}; SameSite=Lax`
    }
}

const AppWebviewStatePersistence = () => {
    const searchParams = useSearchParams()

    useEffect(() => {
        persistAppWebviewState()
    }, [searchParams])

    return null
}

export default AppWebviewStatePersistence
